(() => {
  const isProductPage = () => {
    return document.body.classList.contains('template-product') || window.location.pathname.includes('/products/');
  };

  const getProductInfo = () => document.querySelector('product-info') || document;

  const getMainSubmitButton = () => {
    return getProductInfo().querySelector('button[id^="ProductSubmitButton-"]');
  };

  const getProductTitle = () => {
    return getProductInfo().querySelector('.product__title h1')?.textContent?.replace(/\s+/g, ' ').trim() || '';
  };

  const getProductPrice = () => {
    const priceContainer = getProductInfo().querySelector('[id^="price-"]');
    if (!priceContainer) return '';

    const preferredPrice =
      priceContainer.querySelector('.price__sale .price-item--sale') ||
      priceContainer.querySelector('.price__regular .price-item--regular') ||
      priceContainer.querySelector('.price-item');

    return preferredPrice?.textContent?.replace(/\s+/g, ' ').trim() || '';
  };

  const parseJson = (value, fallback = null) => {
    try {
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  };

  const normalizeImageUrl = (url) => {
    if (!url) return '';
    return url.startsWith('//') ? `${window.location.protocol}${url}` : url;
  };

  const getSelectedVariant = () => {
    const variantJson = getProductInfo().querySelector('variant-selects [data-selected-variant]')?.textContent;
    return parseJson(variantJson, null);
  };

  const getVariantLabel = () => {
    const variant = getSelectedVariant();
    const sku = variant?.sku?.trim();
    const title = variant?.title?.trim();

    if (sku) return sku;
    if (title && title !== 'Default Title') return title;
    return '';
  };

  const getFallbackProductImage = () => {
    const activeMedia =
      document.querySelector('.product__media-item.is-active img') ||
      document.querySelector('.product__media img') ||
      document.querySelector('.product-media-container img');

    return normalizeImageUrl(activeMedia?.currentSrc || activeMedia?.src || '');
  };

  const getSelectedVariantImage = () => {
    const variant = getSelectedVariant();
    const variantImage =
      variant?.featured_media?.preview_image?.src ||
      variant?.featured_media?.src ||
      variant?.featured_image?.src ||
      variant?.featured_image;

    return normalizeImageUrl(variantImage) || getFallbackProductImage();
  };

  const createReturnCard = () => {
    const existing = document.getElementById('ComforsycoReturnToCart');
    if (existing) return existing;

    const card = document.createElement('button');
    card.id = 'ComforsycoReturnToCart';
    card.className = 'comforsyco-return-cart';
    card.type = 'button';
    card.hidden = true;
    card.innerHTML = `
      <img class="comforsyco-return-cart__image" src="" alt="" width="56" height="56" loading="lazy" data-return-to-cart-image hidden>
      <span class="comforsyco-return-cart__content">
        <span class="comforsyco-return-cart__title" data-return-to-cart-title></span>
        <span class="comforsyco-return-cart__variant" data-return-to-cart-variant hidden></span>
        <span class="comforsyco-return-cart__price" data-return-to-cart-price></span>
      </span>
      <span class="comforsyco-return-cart__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M7 8V7a5 5 0 0 1 10 0v1h2.2l.8 13H4L4.8 8H7Zm2 0h6V7a3 3 0 0 0-6 0v1Zm2 5v3H8v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>
        </svg>
      </span>
    `;

    document.body.appendChild(card);
    return card;
  };

  const syncReturnCard = (card) => {
    const image = card.querySelector('[data-return-to-cart-image]');
    const title = card.querySelector('[data-return-to-cart-title]');
    const variant = card.querySelector('[data-return-to-cart-variant]');
    const price = card.querySelector('[data-return-to-cart-price]');
    const imageUrl = getSelectedVariantImage();
    const variantLabel = getVariantLabel();

    title.textContent = getProductTitle();
    price.textContent = getProductPrice();
    variant.textContent = variantLabel;
    variant.hidden = !variantLabel;

    if (image) {
      image.hidden = !imageUrl;
      image.src = imageUrl;
      image.alt = imageUrl ? 'Selected product image' : '';
    }
  };

  const shouldShowCard = () => {
    const mainButton = getMainSubmitButton();
    if (!mainButton) return false;

    const rect = mainButton.getBoundingClientRect();
    return rect.bottom <= 0;
  };

  const updateReturnCard = (card) => {
    syncReturnCard(card);
    card.hidden = !shouldShowCard();
  };

  const scrollToPurchaseArea = () => {
    const mainButton = getMainSubmitButton();
    if (!mainButton) return;

    mainButton.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    window.setTimeout(() => {
      mainButton.focus({ preventScroll: true });
    }, 450);
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!isProductPage()) return;

    const card = createReturnCard();
    card.addEventListener('click', scrollToPurchaseArea);
    updateReturnCard(card);

    window.addEventListener('scroll', () => updateReturnCard(card), { passive: true });
    window.addEventListener('resize', () => updateReturnCard(card));
    document.addEventListener('change', (event) => {
      if (event.target.matches('.product-variant-id, variant-selects input, variant-selects select')) {
        updateReturnCard(card);
      }
    });

    const productInfo = getProductInfo();
    if (productInfo instanceof Element) {
      const observer = new MutationObserver(() => updateReturnCard(card));
      observer.observe(productInfo, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'value'],
      });
    }
  });
})();
